<template>
  <div :style="note" class="register-container">
    <div style="width: 100%; display: flex; flex-direction: column; align-items: center;">
      <div class="header-bar">
        <div class="header-content">
          <router-link to="/" class="title-link">数据资产全过程AI服务平台</router-link>
          <div class="contact-info">联系电话: 15831289727</div>
        </div>
      </div>
      <el-card class="register-card">
        <el-row :gutter="40">
          <h3 class="register-title">用户注册</h3>
          <el-col :span="10" class="register-image">
            <img :src="require('../assets/img/homePage/register_2.jpg')" alt="注册背景图"
              style="width:100%;height:100%;object-fit:cover;border-radius:4px">
          </el-col>
          <el-col :span="14">
            <el-form :rules="rules" ref="registerForm" :model="registerForm" class="register-form">

              <el-form-item prop="userName">
                <el-input v-model="registerForm.userName" placeholder="请输入账号" prefix-icon="el-icon-user" clearable
                  @blur="checkUserName">
                  <template slot="suffix">
                    <i v-if="userNameChecking" class="el-icon-loading" style="margin-right:8px"></i>
                    <i v-else-if="userNameAvailable" class="el-icon-success" style="color:#67C23A;margin-right:8px"></i>
                    <i v-else-if="userNameError" class="el-icon-error" style="color:#F56C6C;margin-right:8px"></i>
                    <el-tooltip v-else content="账号名应为 4-64个字符，可使用字母、数字或下划线，请勿包含空格！" placement="left"
                      effect="light">
                      <i class="el-icon-warning" style="color:#E6A23C;margin-right:8px"></i>
                    </el-tooltip>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item prop="passWord">
                <el-input type="password" v-model="registerForm.passWord" placeholder="请输入密码" prefix-icon="el-icon-lock"
                  clearable @input="validatePassword">
                  <el-tooltip slot="suffix" content="密码长度为 6-20 位，至少包含 1 个大写字母、1 个小写字母和 1 个数字" placement="left"
                    effect="light">
                    <i class="el-icon-warning" style="color:#E6A23C;margin-right:8px"></i>
                  </el-tooltip>
                </el-input>
                <div v-if="passwordError" style="color:#F56C6C;font-size:12px;margin-top:5px">{{ passwordError }}</div>
                <div v-if="passwordStrength" style="color:#67C23A;font-size:12px;margin-top:5px">{{ passwordStrength }}
                </div>
              </el-form-item>
              <el-form-item prop="confirmPassword">
                <el-input type="password" v-model="registerForm.confirmPassword" placeholder="请确认密码"
                  prefix-icon="el-icon-lock" clearable>
                </el-input>
              </el-form-item>
              <el-form-item prop="phone">
                <el-input v-model="registerForm.phone" placeholder="请输入手机号" prefix-icon="el-icon-mobile-phone"
                  clearable>
                </el-input>
              </el-form-item>
              <el-form-item prop="code" style="margin-bottom: 22px">
                <div class="code-input-group">
                  <el-input v-model="registerForm.code" placeholder="请输入验证码" clearable
                    style="width: 70%; margin-right: 5px">
                  </el-input>
                  <el-button @click="sendCode" :disabled="!registerForm.phone || codeSending" style="width: 30%">
                    {{ codeSending ? `${countdown}秒后重试` : '获取验证码' }}
                  </el-button>
                </div>
              </el-form-item>
              <el-form-item>
                <el-checkbox v-model="agreedToTerms" class="agreement-checkbox">
                  <span style="font-weight:bold;color:#333">我已阅读并同意</span>
                  <el-link type="primary" @click="showAgreement = true">
                    《数据资产全过程AI服务平台用户服务协议》
                  </el-link>
                </el-checkbox>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" style="width:100%" @click="submitRegister" :disabled="!agreedToTerms">
                  注册
                </el-button>
              </el-form-item>
              <el-form-item style="text-align:center">
                <el-link type="info" @click="goToLogin">已有账号？去登录</el-link>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-card>

      <el-dialog :visible.sync="showAgreement" width="80%" :before-close="closeAgreement" @opened="startReadTimer"
        custom-class="agreement-dialog">
        <div class="dialog-content-wrapper">
          <user-agreement />
        </div>
        <span slot="footer" class="dialog-footer">
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import UserAgreement from '@/components/UserAgreement.vue';

export default {
  name: "Register",
  components: {
    UserAgreement
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (value !== this.registerForm.passWord) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      registerForm: {
        userName: '',
        passWord: '',
        confirmPassword: '',
        phone: '',
        code: ''
      },
      codeSending: false,
      countdown: 60,
      timer: null,
      passwordError: '',
      passwordStrength: '',
      agreedToTerms: false,
      userNameChecking: false,
      userNameAvailable: false,
      userNameError: '',
      showAgreement: false,
      hasScrolledToBottom: false,
      readTime: 0,
      agreementAccepted: false,
      rules: {
        userName: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          { min: 4, max: 64, message: '长度在4到64个字符', trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9_]+$/, message: '只能包含字母、数字或下划线', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback();
                return;
              }
              if (this.userNameError) {
                callback(new Error(this.userNameError));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        passWord: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在6到20个字符', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (!/[A-Z]/.test(value)) {
                callback(new Error('至少包含1个大写字母'));
              } else if (!/[a-z]/.test(value)) {
                callback(new Error('至少包含1个小写字母'));
              } else if (!/[0-9]/.test(value)) {
                callback(new Error('至少包含1个数字'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        confirmPassword: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      note: {
        backgroundImage: "url(" + require("../assets/img/homePage/register_1.png") + ")",
        backgroundColor: "#f9f9f9",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        position: "absolute",
        backgroundSize: "cover",
        position: "absolute",
        backgroundSize: "cover",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }
    }
  },
  methods: {
    postJsonRequest(url, data) {
      return axios.post(url, data, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
    },
    sendCode() {
      if (!this.registerForm.phone) {
        this.$message.error('请输入手机号');
        return;
      }

      // 验证手机号格式
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(this.registerForm.phone)) {
        this.$message.error('请输入正确的手机号');
        return;
      }

      this.codeSending = true;
      this.countdown = 60;

      axios.get('/web/company/user/sendCode', {
        params: {
          phone: this.registerForm.phone
        }
      }).then(response => {
        this.$message.success('验证码发送成功');
        this.timer = setInterval(() => {
          this.countdown--;
          if (this.countdown <= 0) {
            clearInterval(this.timer);
            this.codeSending = false;
          }
        }, 1000);
      }).catch(error => {
        this.codeSending = false;
        this.$message.error('验证码发送失败');
      });
    },

    submitRegister() {
      //console.log('开始注册流程');
      this.$refs.registerForm.validate(valid => {
        if (!valid) {
          console.warn('表单验证未通过');
          return;
        }

        //console.log('准备提交注册数据:', {
        //   userName: this.registerForm.userName,
        //   phone: this.registerForm.phone,
        //   code: this.registerForm.code
        // });

        if (!this.postJsonRequest) {
          console.error('postJsonRequest方法未定义');
          this.$message.error('系统配置错误，请联系管理员');
          return;
        }

        this.loading = true;
        //console.log('发送注册请求...');

        this.postJsonRequest('/web/company/user/register', {
          userName: this.registerForm.userName,
          passWord: this.registerForm.passWord,
          phone: this.registerForm.phone,
          code: this.registerForm.code
        }).then(resp => {
          //console.log('注册响应:', resp);
          this.loading = false;

          if (!resp) {
            console.error('收到空响应');
            this.$message.error('服务器无响应');
            return;
          }

          if (resp.data.status === 200) {
            //console.log('注册成功');
            this.$message.success('注册成功');
            this.$router.push('/login');
          } else {
            console.warn('注册失败:', resp.data.message);
            this.$message.error(resp.data.message || '注册失败');
          }
        }).catch(err => {
          console.error('注册请求异常:', err);
          this.loading = false;
          let errorMsg = '请求异常: ';

          if (err.response) {
            console.error('响应数据:', err.response.data);
            errorMsg += err.response.data?.message || err.response.statusText;
          } else if (err.request) {
            console.error('无响应:', err.request);
            errorMsg += '服务器无响应';
          } else {
            console.error('请求配置错误:', err.message);
            errorMsg += err.message;
          }

          this.$message.error(errorMsg);
        });
      });
    },
    goToLogin() {
      this.$router.push('/home');
    },
    handleScroll(e) {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        this.hasScrolledToBottom = true;
      }
    },
    startReadTimer() {
      this.readTime = 0;
      this.timer = setInterval(() => {
        this.readTime++;
      }, 1000);
    },
    stopReadTimer() {
      clearInterval(this.timer);
    },
    closeAgreement() {
      this.stopReadTimer();
      this.showAgreement = false;
    },
    confirmAgreement() {
      this.agreedToTerms = true;
      this.closeAgreement();
    },
    checkUserName() {
      const userName = this.registerForm.userName;
      if (!userName || userName.length < 4 || !/^[a-zA-Z0-9_]+$/.test(userName)) {
        this.userNameAvailable = false;
        this.userNameError = '';
        return;
      }

      this.userNameChecking = true;
      this.userNameError = '';
      this.userNameAvailable = false;

      this.$axios.get('/web/company/user/checkUserName', {
        params: {
          userName: this.registerForm.userName
        }
      }).then(response => {
        if (response.data.status === 200) {
          this.userNameAvailable = true;
          this.$message.success('用户名可用');
        } else {
          this.userNameError = response.data.msg || '用户名不可用';
          this.$message.error(this.userNameError);
        }
      }).catch(error => {
        this.userNameError = error.response?.data?.msg || '用户名检查失败';
        this.$message.error(this.userNameError);
      }).finally(() => {
        this.userNameChecking = false;
      });
    },

    validatePassword() {
      const password = this.registerForm.passWord;
      if (!password) {
        this.passwordError = '';
        this.passwordStrength = '';
        return;
      }

      if (password.length < 6) {
        this.passwordError = '密码长度不足6位';
        this.passwordStrength = '';
      } else if (!/[A-Z]/.test(password)) {
        this.passwordError = '密码缺少大写字母';
        this.passwordStrength = '';
      } else if (!/[a-z]/.test(password)) {
        this.passwordError = '密码缺少小写字母';
        this.passwordStrength = '';
      } else if (!/[0-9]/.test(password)) {
        this.passwordError = '密码缺少数字';
        this.passwordStrength = '';
      } else {
        this.passwordError = '';

        // 评估密码强度
        const strength =
          (password.length >= 12 ? 1 : 0) +
          (/[^A-Za-z0-9]/.test(password) ? 1 : 0);

        if (strength >= 1) {
          this.passwordStrength = '密码强度：强';
        } else {
          this.passwordStrength = '密码强度：中';
        }
      }
    }
  }
}
</script>

<style scoped>
.register-container {
  min-width: 100vw;
  overflow-x: auto;
  position: relative;
  width: fit-content;
}

.register-card {
  min-width: 1000px;
  width: auto;
  transition: none;
}

.register-form .el-input,
.register-form .el-button {
  width: 80% !important;
  transform-origin: left center;
}

.register-form .el-form-item {
  margin-bottom: 22px;
  transform: none !important;
}

@media screen and (max-width: 768px) {
  .register-container {
    width: 100%;
    min-width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  
  .register-card {
    min-width: 100%;
    width: auto;
  }
  
  body {
    overflow-x: hidden;
    position: relative;
  }
  
  html {
    overflow-x: hidden;
  }
}

/* 保持输入框样式不变 */
.el-input__inner,
.el-button,
.el-checkbox__label,
.el-link {
  transform: none !important;
  font-size: 14px !important;
  padding: 12px 15px !important;
}

/* 水平滚动条样式 */
::-webkit-scrollbar {
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.agreement-dialog {
  height: 300px !important;
  max-height: 300px !important;
  display: flex;
  flex-direction: column;
  margin: auto !important;
  top: 50%;
  transform: translateY(-50%);
  overflow: hidden;
}

.dialog-content-wrapper {
  height: calc(100% - 40px);
  overflow-y: auto;
  padding: 20px;
  margin: -20px;
}

.agreement-dialog .el-dialog__body {
  padding: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.register-card {
  width: 1000px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-top: 80px;
}

.header-bar {
  width: 100%;
  background-color: #409EFF;
  color: white;
  padding: 15px 0;
  margin-bottom: 20px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}

.header-content {
  width: 1000px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title-link {
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  text-decoration: none;
  letter-spacing: 1px;
}

.title-link:hover {
  text-decoration: underline;
}

.contact-info {
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  text-decoration: none;
  letter-spacing: 1px;
}

.register-form {
  padding: 30px;
}

.register-form .el-form-item {
  margin-bottom: 22px;
}

.register-form .el-input,
.register-form .el-button {
  width: 80%;
}

  .code-input-group {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
  }

.register-title {
  font-weight: bold;
  margin: 0 0 30px 0;
  text-align: center;
  color: #000000;
  font-size: 28px;
}

.register-image {
  height: 500px;
  overflow: hidden;
}

@media (max-width: 768px) {
  .register-card {
    width: 100%;
    margin-top: 20px;
  }

  .register-image {
    display: none;
  }

  .register-form {
    padding: 15px;
  }
  
  .register-form .el-input,
  .register-form .el-button {
    width: 100% !important;
  }
  
  .code-input-group {
    flex-direction: column;
  }
  
  .code-input-group .el-input {
    width: 100% !important;
    margin-bottom: 10px;
  }
  
  .code-input-group .el-button {
    width: 100% !important;
  }
  
  .el-col-14 {
    width: 100%;
  }
  
  .header-content {
    flex-direction: column;
    text-align: center;
    padding: 0 10px;
  }
  
  .title-link, .contact-info {
    font-size: 16px;
    margin: 5px 0;
  }
}

.agreement-checkbox .el-checkbox__label {
  font-weight: bold;
  color: #333;
  font-size: 14px;
}

.agreement-checkbox .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #333;
}

.agreement-checkbox .el-link {
  font-size: 15px;
  font-weight: bold;
  color: #409EFF;
}

.dialog-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.registerTitle {
  margin: 0 auto 30px auto;
  text-align: center;
  color: #505458;
}
</style>